export interface PickPointVideoItemType {
  url: string
  name: string
  format?: string
}

export type PickPointFileItemType = {
  url: string
  type: PickPointFileType
  isPublic: boolean
  size: number
}

export enum PickPointFileType {
  /** Фасад здания днем */
  generalPhoto = 'generalPhoto',
  /** Фасад здания с выделенной зоной под вывеску */
  nightlyGeneralPhoto = 'nightlyGeneralPhoto',
  /** Кронштейн */
  bracketPhoto = 'bracketPhoto',
  /** Входная группа */
  fittingRoomsPhoto = 'fittingRoomsPhoto',
  /** Помещение внутри */
  clientAreaPhoto = 'clientAreaPhoto',
  /** Фото складской зоны */
  warehouseAreaPhoto = 'warehouseAreaPhoto',
  /** Фото видеонаблюдения */
  surveillancePhoto = 'surveillancePhoto',

  /** Видеопрогулка */
  video = 'video',

  /** Документ аренды */
  leaseDocument = 'leaseDocument',
  /** Документ БТИ */
  btiDocument = 'btiDocument',

  /** Документ аренды используемый при редактировании площади ПВЗ */
  leaseDocumentEditArea = 'leaseDocumentEditArea',
  /** Документ БТИ используемый при редактировании площади ПВЗ */
  btiDocumentEditArea = 'btiDocumentEditArea',
}

export type WeekDays = {
  label: string
  value: string
  isDayOff: boolean
}

export type WorkTime = {
  open: string
  close: string
}

type TimetableDay = WorkTime & { is_day_off: boolean }
export type TimetableDays = { [key: string]: TimetableDay }

export interface Timetable {
  daily: WorkTime
  sat: WorkTime
  sun: WorkTime
  week: {
    days: TimetableDays
  }
}

export enum PickPointType {
  none = 'TYPE_POINT_NONE',
  /** партнёрский ПВЗ брендированный (стандартный тариф) */
  partner = 'TYPE_POINT_8',
  /** народный ПВЗ (упрощенный тариф) */
  folk = 'TYPE_POINT_28',
}
